import merge from 'lodash/merge';
import { getQueryStringParams } from 'srcAlias/utils/url';

export default (initialState = {}) => {
  const { segmentState } = getQueryStringParams(undefined, {
    parse: false,
  });

  if (segmentState) {
    return merge(initialState, segmentState);
  }

  return initialState;
};
